"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VuexModule = /** @class */ (function () {
    function VuexModule() {
    }
    VuexModule.With = function (options) {
        return VuexModule;
    };
    return VuexModule;
}());
exports.VuexModule = VuexModule;
//# sourceMappingURL=interfaces.js.map